import { useEffect, useState } from "react";
import { Form } from 'antd';
import Moment from 'moment';
import API from "../../../../../services/API";

export default function useStatementGenerate({ newStatements }) {
  const todayMoment = Moment();
  const currentReportingCycle = todayMoment.format('YYYYMM');
  const currentWeekReportingDay = todayMoment.day() === 1
    ? todayMoment.isoWeekday(-7).format('YYYY-MM-DD')
    : todayMoment.subtract(1, 'days').format('YYYY-MM-DD');

  const [newStatementsForm] = Form.useForm();
  const [reportingCycles, setReportingCycles] = useState({});
  const [newFurnishingStatements, setNewFurnishingStatements] = useState([]);
  
  useEffect(() => {

    const newReportingCycles = {};

    const newStatementsToPatch = newStatements.map((statement) => {

      if (newReportingCycles[statement.reportingCycle]) {
        return null;
      }

      newReportingCycles[statement.reportingCycle] = {
        newStatement: true,
        shouldPersist: false,
        status: false,
        patching: false,
        errorMsg: false,
        response: null
      };

      const newStatementDate = currentReportingCycle === statement.reportingCycle
        ? Moment(currentWeekReportingDay)
          : Moment(statement.statementDate).add(1, 'day');

      return {
        ...statement,
        statementId: crypto.randomUUID(),
        statementDate: newStatementDate,
        isClosed: false,
        isClosedDisabled: currentReportingCycle !== statement.reportingCycle
      };
    }).filter((statement) => !!statement);

    if (newReportingCycles[currentReportingCycle]) {
      setNewFurnishingStatements(newStatementsToPatch);
      newStatementsForm.setFieldsValue({ statements: newStatementsToPatch });

    } else {
      newReportingCycles[currentReportingCycle] = {
        newStatement: true,
        shouldPersist: false,
        status: false,
        patching: false,
        errorMsg: false,
        response: null
      };

      const newStatementsToPatchWithCurrentReportingCycle = [{
        reportingCycle: currentReportingCycle,
        statementId: crypto.randomUUID(),
        statementDate: Moment(currentWeekReportingDay),
        isClosed: false,
        isClosedDisabled: false
      }].concat(newStatementsToPatch);

      setNewFurnishingStatements(newStatementsToPatchWithCurrentReportingCycle);
      newStatementsForm.setFieldsValue({ statements: newStatementsToPatchWithCurrentReportingCycle });
      console.log({newStatementsToPatchWithCurrentReportingCycle})
    }
    
    setReportingCycles(newReportingCycles);
  }, [newStatements]);

  const statementToBloomAccountEntry = (statement, reportingCycle) => {
    return {
      statementId: statement.id,
      statementDate: statement.statementDate,
      currentBalance: statement.currentBalance,
      amountPastDue: statement.amountPastDue,
      daysDelinquent: statement.daysOverdue,
      dateOfFirstDelinquency: statement.dateOfFirstDelinquency,
      scheduledMonthlyPayment: statement.scheduledMonthlyPayment,
      actualMonthlyPayment: statement.actualMonthlyPayment,
      paymentDueDate: statement.paymentDueDate,
      lastPaymentDate: statement.lastPaymentDate,
      reportingCycle: reportingCycle
    }
  }

  const generateStatements = (data) => {
    const {
      reporting_cycle: reportingCycle,
      shouldPersist
    } = data;

    setReportingCycles((prev) => ({
      ...prev,
      [data.reportingCycle]: {
        ...prev[data.reportingCycle],
        status: false,
        patching: true,
        errorMsg: false,
        statement: null,
        shouldPersist
      }
    }));
    return API.postCreateStatement(data).then((response) => {
      console.log('generated', data, response)
      setReportingCycles((prev) => ({
        ...prev,
        [data.reportingCycle]: {
          ...prev[data.reportingCycle],
          status: true,
          patching: false,
          errorMsg: false,
          statement: statementToBloomAccountEntry(response.statement, reportingCycle)
        }
      }));
    }).catch((error) =>{
      setReportingCycles((prev) => ({
        ...prev,
        [data.reportingCycle]: {
          ...prev[data.reportingCycle],
          status: false,
          patching: false,
          errorMsg: error.message,
          statement: null
        }
      }));
    })
  };


  return {
    reportingCycles,
    newStatementsForm,
    newFurnishingStatements,
    generateStatements
  }
};